// 抛出登录请求状态
import {
	login,
	logout,
	getInfo,
	mobile_login,
	get_menu_list
} from '@/api/user'
// 抛出token状态
import {
	getToken,
	setToken,
	removeToken,
	setSession,
	getlocalStorage,
	setlocalStorage
} from '@/utils/auth'
const state = {
	token: getToken(),
	rubik_cube_id: '',
	mobile: '',
	home_mobile: '',
	home_role_name: '',
	home_name: '',
	username: '',
	company: '',
	email: '',
	avatar: '',
	cartnum: 0,
	balance: 0,
	warning_mobile:'',
	points: 0,
	alipay_account: '',
	alipay_name: '',
	cash_money: '',
	auth_status: '',
	user_audits_status: '',
	warning_value: '',
	is_warning: '',
	config: {},
	gz_openid: '',
	member_end_time: '',
	member_start_time: '',
	member_type: '',
	super_member_end_time: '',
	super_member_start_time: '',
	audit_type: '',
	business_identity: '',
	linkman: '',
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_MOBILE: (state, mobile) => {
		state.mobile = mobile
	},
	SET_NAME: (state, name) => {
		state.username = name
	},
	SET_COMPANY: (state, name) => {
		state.company = name
	},
	SET_EMAIL: (state, name) => {
		state.email = name
	},
	SET_CONTACT_PERSON: (state, contact_person) => {
		state.contact_person = contact_person
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_CARTNUM: (state, cartnum) => {
		state.cartnum = cartnum
	},
	SET_BALANCE: (state, balance) => {
		state.balance = balance
	},
	SET_WARNING_MOBILE:(state, warning_mobile) => {
		state.warning_mobile = warning_mobile
	},
	SET_POINTS: (state, points) => {
		state.points = points
	},
	SET_ALIPAY_ACCOUNT: (state, alipay_account) => {
		state.alipay_account = alipay_account
	},
	SET_ALIPAY_NAME: (state, alipay_name) => {
		state.alipay_name = alipay_name
	},
	SET_CASH_MONEY: (state, cash_money) => {
		state.cash_money = cash_money
	},
	SET_AUTH_STATUS: (state, auth_status) => {
		state.auth_status = auth_status
	},
	SET_AUTH_STATUS_USER: (state, user_audits_status) => {
		state.user_audits_status = user_audits_status
	},
	SET_WARNING_VALUE: (state, warning_value) => {
		state.warning_value = warning_value
	},
	SET_IS_WARNING: (state, is_warning) => {
		state.is_warning = is_warning
	},
	SET_OPENID: (state, openid) => {
		state.gz_openid = openid
	},
	SET_HOME_MOBILE: (state, home_mobile) => {
		state.home_mobile = home_mobile
	},
	SET_HOME_ROLE_NAME: (state, home_role_name) => {
		state.home_role_name = home_role_name
	},
	SET_HOME_NAME: (state, home_name) => {
		state.home_name = home_name
	},
	SET_MEMBER_END_TIME: (state, member_end_time) => {
		state.member_end_time = member_end_time
	},
	SET_MEMBER_START_TIME: (state, member_start_time) => {
		state.member_start_time = member_start_time
	},
	SET_MEMBER_TYPE: (state, member_type) => {
		state.member_type = member_type
	},
	SET_SUPER_MEMBER_END_TIME: (state, super_member_end_time) => {
		state.super_member_end_time = super_member_end_time
	},
	SET_SUPER_MEMBER_START_TIME: (state, super_member_start_time) => {
		state.super_member_start_time = super_member_start_time
	},
	SET_AUDIT_TYPE: (state, audit_type) => {
		state.audit_type = audit_type
	},
	SET_BUSINESS_IDENTITY: (state, business_identity) => {
		state.business_identity = business_identity
	},
	SET_LINKMAN: (state, linkman) => {
		state.linkman = linkman
	},
	SET_PERSON_AUDIT: (state, is_open_person_audit) => {
		state.is_open_person_audit = is_open_person_audit
	},
}

const actions = {
	// user login
	login({
		commit
	}, userInfo) {
		const {
			userName,
			password
		} = userInfo
		return new Promise((resolve, reject) => {
			login({
				mobile: userName.trim(),
				password
			}).then(response => {
				const {
					data
				} = response
				commit('SET_TOKEN', data.token)
				localStorage.setItem('ifRel', 0)
				if (data.avatar) {
					commit('SET_AVATAR', data.avatar)
				} else {
					// 默认头像
					commit('SET_AVATAR',
						'https://images.houniao.hk/houniao-images/shop/admin_image/upload/20220106/61d6acabc6f8c.png'
					)
				}

				setToken(data.token)
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	mobile_login({
		commit
	}, userInfo) {
		const {
			userName,
			sms_code
		} = userInfo
		return new Promise((resolve, reject) => {
			mobile_login({
				mobile: userName.trim(),
				sms_code
			}).then(response => {
				const {
					data
				} = response
				commit('SET_TOKEN', data.token)
				localStorage.setItem('ifRel', 0)
				if (data.avatar) {
					commit('SET_AVATAR', data.avatar)
				} else {
					// 默认头像
					commit('SET_AVATAR',
						'https://images.houniao.hk/houniao-images/shop/admin_image/upload/20220106/61d6acabc6f8c.png'
					)
				}

				setToken(data.token)
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	// get user info
	getInfo({
		commit,
		state
	}) {
		return new Promise((resolve, reject) => {
			// console.log(state,'getInfo')
			if (!state.token) {
				reject('登录失效，请重新登录');
				localStorage.removeItem('ifRel')
				commit('SET_TOKEN', '')
				removeToken()
				return;
			}
			getInfo().then(response => {
				const {
					data
				} = response
				console.log(1,'state/modules/user.js getInfo')
				if (data.auth == 0) {
					localStorage.setItem('ifRel', 1)
				}
				if (localStorage.getItem('ifRel') == 1 && data.auth == 1) {
					//重新登录
					localStorage.removeItem('ifRel')
					commit('SET_TOKEN', '')
					removeToken()
				} else {
					get_menu_list({
						effect: 0
					}).then(res => {
						if (res.code === 200) {
							const {
								data
							} = res
							if (!data) {}
							const {
								menu_list
							} = data
							setSession('menu_list', JSON.stringify(res.data))
						} else {
							return false
						}
					})
					get_menu_list({
						effect: 2
					}).then(res => {
						if (res.code === 200) {
							const {
								data
							} = res
							if (!data) {}
							const {
								menu_list
							} = data
							setSession('top_menu_list', JSON.stringify(res.data))
						} else {
							return false
						}
					})
				}
				setSession('is_newcomer', JSON.stringify(data.is_newcomer))
				commit('SET_MEMBER_END_TIME', data.member_end_time)
				commit('SET_MEMBER_START_TIME', data.member_start_time)
				commit('SET_MEMBER_TYPE', data.member_type)
				commit('SET_SUPER_MEMBER_END_TIME', data.super_member_end_time)
				commit('SET_SUPER_MEMBER_START_TIME', data.super_member_start_time)
				commit('SET_AUDIT_TYPE', data.user_audits_info.audit_type)
				commit('SET_BUSINESS_IDENTITY', data.user_audits_info.business_identity)
				commit('SET_LINKMAN', data.user_audits_info.linkman)
				commit('SET_PERSON_AUDIT', data.is_open_person_audit)
				commit('SET_MOBILE', data.mobile)
				commit('SET_HOME_MOBILE', data.home_shop_user_mobile)
				commit('SET_HOME_ROLE_NAME', data.home_shop_user_role_name)
				commit('SET_HOME_NAME', data.home_shop_user_name)
				commit('SET_NAME', data.username)
				commit('SET_COMPANY', data.company)
				commit('SET_EMAIL', data.email)
				commit('SET_CONTACT_PERSON', data.contact_person)
				commit('SET_CARTNUM', data.cart_num)
				commit('SET_BALANCE', data.user_money)
				commit('SET_WARNING_MOBILE', data.warning_mobile)
				commit('SET_POINTS', data.points)
				commit('SET_ALIPAY_ACCOUNT', data.alipay_account)
				commit('SET_ALIPAY_NAME', data.alipay_name)
				commit('SET_CASH_MONEY', data.cash_money)
				commit('SET_AUTH_STATUS', data.auth)
				commit('SET_AUTH_STATUS_USER', data.user_audits_status)
				commit('SET_WARNING_VALUE', data.warning_value)
				commit('SET_IS_WARNING', data.is_warning)
				commit('SET_OPENID', data.gz_openid)
				if (data.avatar) {
					commit('SET_AVATAR', data.avatar)
				} else {
					// 默认头像
					commit('SET_AVATAR',
						'https://images.houniao.hk/houniao-images/shop/admin_image/upload/20220106/61d6acabc6f8c.png'
					)
				}
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},



	// user logout
	logout({
		commit
	}) {
		return new Promise((resolve, reject) => {
			logout().then(() => {
				commit('SET_TOKEN', '')
				commit('SET_MOBILE', '')
				commit('SET_COMPANY', '')
				commit('SET_EMAIL', '')
				commit('SET_CONTACT_PERSON', '')
				commit('SET_NAME', '')
				commit('SET_CARTNUM', '')
				commit('SET_BALANCE', '')
				commit('SET_WARNING_MOBILE', '')
				commit('SET_POINTS', '')
				commit('SET_ALIPAY_ACCOUNT', '')
				commit('SET_ALIPAY_NAME', '')
				commit('SET_CASH_MONEY', '')
				commit('SET_AUTH_STATUS', '')
				commit('SET_AUTH_STATUS_USER', '')
				commit('SET_WARNING_VALUE', '')
				commit('SET_IS_WARNING', '')
				commit('SET_AVATAR', '')
				commit('SET_OPENID', '')
				commit('SET_PERSON_AUDIT', '')
				removeToken()
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	// remove token
	resetToken({
		commit
	}) {
		return new Promise(resolve => {
			commit('SET_TOKEN', '')
			commit('SET_MOBILE', '')
			commit('SET_COMPANY', '')
			commit('SET_EMAIL', '')
			commit('SET_CONTACT_PERSON', '')
			commit('SET_NAME', '')
			commit('SET_CARTNUM', '')
			commit('SET_BALANCE', '')
			commit('SET_WARNING_MOBILE', '')
			commit('SET_POINTS', '')
			commit('SET_ALIPAY_ACCOUNT', '')
			commit('SET_ALIPAY_NAME', '')
			commit('SET_CASH_MONEY', '')
			commit('SET_AUTH_STATUS', '')
			commit('SET_WARNING_VALUE', '')
			commit('SET_IS_WARNING', '')
			commit('SET_AVATAR', '')
			commit('SET_PERSON_AUDIT', '')
			removeToken()
			resolve()
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}